import { prodReferralsApi } from './referrals-api.prod'

export const referralsApi = prodReferralsApi

export type { GetReferralsResult, ReferralsApi } from './referrals-api.types'
